import { acceptHMRUpdate, defineStore } from "pinia";
import type { Locale } from "@/i18n/config";
import { setLocaleCookie, getLocaleCookie } from "@/utils/cookies";

export type I18nLangCode = Locale;

export const useLocalesStore = defineStore("i18n", {
	state: () => ({
		locale: "" as I18nLangCode, // Initial locale as a string
		availableLocales: [] as I18nLangCode[], // Initial available locales
	}),
	actions: {
		initLocale() {
			const globalI18n = useNuxtApp().$i18n;

			// Set available locales and current locale from i18n instance
			// @ts-ignore
			this.availableLocales = globalI18n.availableLocales as I18nLangCode[];
			const localeFromCookie = getLocaleCookie();

			if (localeFromCookie) {
				// @ts-ignore
				globalI18n.locale.value = localeFromCookie;
				// @ts-ignore
				this.locale = localeFromCookie;
			} else {
				// @ts-ignore
				this.locale = globalI18n.locale.value as I18nLangCode;
			}
		},
		setLocale(locale: I18nLangCode): void {
			const globalI18n = useNuxtApp().$i18n;

			// @ts-ignore
			globalI18n.locale.value = locale;
			this.locale = locale;
			setLocaleCookie(locale);
			//console.log(`Locale set to: ${locale}`);
		},
	},
	getters: {
		t() {
			const globalI18n = useNuxtApp().$i18n;
			// @ts-ignore
			return globalI18n.t;
		},
	},
});

/*
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useLocalesStore, import.meta.hot));
}*/
